import { useState } from "react";
import { useTranslation } from "react-i18next";
import icon_true from '../../img/Accounts/AccountTypes/true.svg';
import icon_false from '../../img/Accounts/AccountTypes/false.svg';

const accounts = [
    [
        'STANDARD',
        '100 USD',
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_false
        },
        {
            icon: icon_false
        },
        {
            icon: icon_true
        },
        {
            icon: icon_false
        },
        {
            icon: icon_false
        },
        {
            icon: icon_false
        },
        {
            icon: icon_false
        },
        {
            icon: icon_false
        },
    ],
    [
        'ELITE',
        '1 000 USD',
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        '+15%',
        {
            icon: icon_false
        },
        {
            icon: icon_false
        },
        {
            icon: icon_false
        },
    ],
    [
        'PRO',
        '10 000 USD',
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        '+15%',
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_false
        },
    ],
    [
        'VIP',
        '50 000 USD',
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        '+15%',
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
        {
            icon: icon_true
        },
    ],
];

const rows = [
    'accounts.account_types.row_01',
    'accounts.account_types.row_02',
    'accounts.account_types.row_03',
    'accounts.account_types.row_04',
    'accounts.account_types.row_05',
    'accounts.account_types.row_06',
    'accounts.account_types.row_07',
    'accounts.account_types.row_08',
    'accounts.account_types.row_09',
    'accounts.account_types.row_10',
    'accounts.account_types.row_11',
    'accounts.account_types.row_12',
    'accounts.account_types.row_13',
    'accounts.account_types.row_14',
];

const AccountTypes = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="hidden md:block">
                    {rows.map((row, rowIndex) =>
                        <div
                            key={rowIndex}
                            className={`grid text-[14px] text-[#0C2780] font-[${rowIndex === 0 ? '700' : '400'}] border-b-[1px] border-b-[#00000030]`}
                            style={{ gridTemplateColumns: 'auto 1fr 1fr 1fr 1fr' }}
                        >
                            <p className={`flex xl:w-[325px] w-[270px] items-center px-[15px] py-[5px] ${rowIndex === 0 ? 'bg-[#B3B7D0]' : ''}`}>
                                {t(row)}
                            </p>
                            {accounts.map((account, accIndex) =>
                                <div className={`flex bg-[${rowIndex === 0 ? '#B3B7D0' : '#EAEBED'}] ${rowIndex === 1 ? 'font-[700]' : ''} items-center min-h-[45px] justify-center px-[15px] py-[5px]`} key={accIndex}>
                                    {typeof (account[rowIndex]) === 'string' ?
                                        <p className="text-center">
                                            {account[rowIndex]}
                                        </p>
                                        :
                                        <img className="" src={account[rowIndex].icon} alt='' />
                                    }
                                </div>
                            )}
                        </div>
                    )}
                    <div
                        className={`grid text-[14px] text-[#fff] font-[700]`}
                        style={{ gridTemplateColumns: 'auto 1fr 1fr 1fr 1fr' }}
                    >
                        <p className={`flex xl:w-[325px] w-[270px] items-center px-[15px] py-[5px]`}></p>
                        {accounts.map((account, accIndex) =>
                            <div className={`flex bg-[#15318D] group hover:bg-[#CEDFF2] cursor-pointer transition-all items-center min-h-[45px] justify-center px-[15px] py-[5px]`} key={accIndex}>
                                <a href="https://user.arvest-solid.net"><p className="text-center group-hover:text-[#000E59]">
                                    {t('stock.20')}
                                </p></a>
                            </div>
                        )}
                    </div>
                </div>
                <div className="md:hidden grid grid-cols-2 gap-[4px] mb-[25px]">
                    {accounts.map((acc, index) =>
                        <div
                            key={index}
                            onClick={() => setActive(index)}
                            className={`flex items-center justify-center text-center text-[14px] text-[#0C2780] font-[700] min-h-[38px] duration-500`}
                            style={{ background: active === index ? '#B3B7D0' : '#B3B7D066' }}
                        >
                            {acc[0]}
                        </div>
                    )}
                </div>
                <div className="md:hidden block">
                    {rows.map((row, rowIndex) =>
                        <div
                            key={rowIndex}
                            className={`grid text-[14px] text-[#0C2780] font-[${rowIndex === 0 ? '700' : '400'}] border-b-[1px] border-b-[#00000030]`}
                            style={{ gridTemplateColumns: '60% 40%' }}
                        >
                            <p className={`flex items-center sm:px-[15px] px-[10px] sm:py-[5px] py-[2px] ${rowIndex === 0 ? 'bg-[#B3B7D0]' : ''}`}>
                                {t(row)}
                            </p>
                            <div className={`flex bg-[${rowIndex === 0 ? '#B3B7D0' : '#EAEBED'}] ${rowIndex === 1 ? 'font-[700]' : ''} items-center min-h-[45px] justify-center px-[15px] py-[5px]`}>
                                {typeof (accounts[active][rowIndex]) === 'string' ?
                                    <p className="text-center">
                                        {accounts[active][rowIndex]}
                                    </p>
                                    :
                                    <img className="" src={accounts[active][rowIndex].icon} alt='' />
                                }
                            </div>
                        </div>
                    )}
                    <div
                        className={`grid text-[14px] text-[#fff] font-[700]`}
                        style={{ gridTemplateColumns: '60% 40%' }}
                    >
                        <p className={`flex items-center px-[15px] py-[5px]`}></p>
                        <div className={`flex bg-[#15318D] items-center min-h-[45px] justify-center px-[15px] py-[5px]`}>
                            <p className="text-center">
                                {accounts[active][0]}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default AccountTypes;
